import { Typography } from "@mui/material";
import DateRangePicker from "components/DateRangePicker";
import { useTranslation } from "react-i18next";
import { CSSObject } from "types/types";

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyItems: "flex-start",
    "@media print": {
      breakInside: "avoid",
      pageBreakBefore: "avoid",
      pageBreakAfter: "avoid",
    },
  },
} satisfies CSSObject;
interface IToolBarProps {
  setDateRange(range: [Date | null, Date | null]): void;
  dateRange: [Date | null, Date | null];
}
const ToolBar = ({ dateRange, setDateRange }: IToolBarProps) => {
  const { i18n } = useTranslation();
  const [startDate, endDate] = dateRange;

  return (
    <Typography
      component="div"
      sx={{ ...customStyles.root, direction: i18n.dir() }}
    >
      <DateRangePicker
        setDateRange={setDateRange}
        startDate={startDate}
        endDate={endDate}
        locale={i18n.dir() === "rtl" ? "ar" : "en"}
      />
    </Typography>
  );
};
export default ToolBar;
